<template>
  <div>
    <AppSpinner
      v-if="loading"
      class="page-spinner"
    />

    <div v-else>
      <div class="mb-4">
        <AppButton
          :disabled="loading"
          class="btn-solid btn-secondary rounded-sm"
          @click="showMetadataModal = true"
        >
          <FontAwesomeIcon :icon="faUpToLine" />
          Upload Metadata
        </AppButton>
      </div>

      <AppTable
        :loading="loadingTable"
        :if-looped-items-exist="metadataArray?.length > 0"
        class="max-w-7xl"
      >
        <template #headings>
          <th>
            Bib Number
          </th>

          <th>
            Athlete Name
          </th>

          <th>
            Team
          </th>

          <th>
            Club
          </th>

          <th>
            Race Time<br>

            <small>(minutes:seconds.milliseconds)</small>
          </th>
        </template>

        <template #rows>
          <tr
            v-for="metadata in metadataArray"
            :key="metadata.id"
          >
            <td>
              {{ metadata?.bibNumber || '-' }}
            </td>

            <td>
              {{ metadata.athleteName }}
            </td>

            <td>
              {{ metadata.team || '-' }}
            </td>

            <td>
              {{ metadata.club || '-' }}
            </td>

            <td>
              {{ metadata.raceTime || '-' }}
            </td>
          </tr>
        </template>
      </AppTable>
    </div>

    <Transition name="fade">
      <UploadMetadataModal
        v-if="showMetadataModal === true"
        :processing="isSubmitting"
        :validation-error="errors"
        @upload="handleUploadMetadata"
        @close="showMetadataModal = false"
      />
    </Transition>
  </div>
</template>

<script setup>
import { HttpStatusCode } from 'axios';
import { ref } from 'vue';
import { useRoute } from 'vue-router';

import {
  AppContainer,
  AppButton,
  AppSpinner,
} from '@/components/app';

import { AppTable } from '@/components/app';
import { UploadMetadataModal } from '@/components/modals';

import { useFormSubmit, useHttp } from '@/composables';

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faUpToLine } from '@fortawesome/pro-solid-svg-icons';

const route = useRoute();

const loading = ref(true);
const loadingTable = ref(false);
const metadataArray = ref({});
const showMetadataModal = ref(false);

const { isSubmitting, errors } = useFormSubmit();

const loadMetadata = async () => {
  loading.value = true;

  const response = await useHttp().get(`/events/${route.params.slug}/metadata`);

  if (response.statusCode === HttpStatusCode.Ok) {
    metadataArray.value = response.data.items;
  }

  loading.value = false;
  loadingTable.value = false;
};

loadMetadata();

const handleUploadMetadata = async (fileData) => {
  errors.value = null;
  isSubmitting.value = true;

  const data = new FormData();

  data.set('file', fileData.metadata);

  const response = await useHttp().post(`/events/${route.params.slug}/metadata`, data);

  if (response.statusCode === HttpStatusCode.Ok) {
    metadataArray.value = response.data.items;
    showMetadataModal.value = false;
  } else if (response.statusCode === HttpStatusCode.UnprocessableEntity) {
    errors.value = response.errors?.file[0] || response.exception;
  }

  isSubmitting.value = false;
};
</script>
